<template>
  <div class="input">
    <div class="page page-first" v-if="currentPage === CURRENT_PAGE.FIRST">
      <h2 class="ttl-main">これからアイデアを検討したい”メインテーマ”を記入</h2>
      <div>
      <input
        type="text"
        v-model="mainKeyword"
        placeholder="キーワードを入力"
        class="input"
      /><button type="button" class="btn btn-dark" v-on:click="setMainKeyword">次へ</button>
      </div>
      <p class="txt-small">※処理は全てブラウザ上(JavaScript)で行なっているため、<br>当サーバーに記入データが送られることはありません。</p>
      <div><AdBnr></AdBnr></div>
    </div>
    <div class="page page-second" v-if="currentPage === CURRENT_PAGE.SECOND">
      <div class="inner">
        <div class="block-input-main">
          <div class="block-input-field">
            <div
              class="block-input-set"
              v-for="(keyblock,index) in getSecondKeyblocks"
              v-bind:key="index"
              v-bind:class="index"
            >
              <textarea
                v-on:keyup="setSecondKeyword(keyblock,index)"
                v-on:change="setSecondKeyword(keyblock,index)"
                v-model="getSecondKeyblocks[index]"
                placeholder="キーワードを入力"
                v-bind:disabled="index=='middleCenter'"
                class="textarea"
              />
            </div>
          </div>
        </div>

        <div
          class="contents-input-child"
          v-for="(keyblocks,index) in getChildKeyblocks"
          v-bind:key="index"
        >
          <div class="block-input-field" v-bind:class="index" v-if="keyblocks.middleCenter">
            <div
              class="block-input-set"
              v-for="(key,childIndex) in keyblocks"
              v-bind:key="childIndex"
              v-bind:class="childIndex"
            >
              <textarea
                v-on:keyup.enter="setChildKeyword(key,index,childIndex)"
                v-model="getChildKeyblocks[index][childIndex]"
                placeholder="キーワードを入力"
                v-bind:disabled="childIndex=='middleCenter'"
                class="textarea"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//設定値読み込み
import { CURRENT_PAGE } from "../lib/definitions.js";


import AdBnr from "./AdBnr.vue";

export default {
  name: "Block",
  components: {
    AdBnr
  },
  data() {
    return {
      //現在のページのenum用
      CURRENT_PAGE: CURRENT_PAGE,
      //現在のページ
      currentPage: CURRENT_PAGE.FIRST,
      //メインキーワード
      mainKeyword: ""
    };
  },
  computed: {
    //メインキーワードをstateから取得
    getMainKeyword() {
      return this.$store.state.mainKeyword;
    },
    //2ページ目キーワードをstateから取得
    getSecondKeyblocks() {
      return this.$store.state.secondKeyblocks;
    },
    //3階層目のキーワードをstateから取得
    getChildKeyblocks() {
      return this.$store.state.childKeyBlocks;
    }
  },
  methods: {
    //メインキーワード設定
    setMainKeyword() {
      this.$store.commit("setMainKeyword", this.mainKeyword);
      this.currentPage = CURRENT_PAGE.SECOND;
    },
    //2ページ目のキーワードを設定
    setSecondKeyword(keyblock, index) {
      this.$store.commit("setSecondKeyword", { keyblock, index });
    },
    //3階層目のキーワードを設定
    setChildKeyword(keyblock, index, childIndex) {
      this.$store.commit("setChildKeyBlocks", { keyblock, index, childIndex });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//ページ全体css
.page {
  position: relative;
  width: 100%;
  max-width: 1200px;
  height: 100vh;
  margin: 0 auto;
  //プレースホルダー共通
  ::placeholder {
    color: #bebebe;
    font-size: 12px;
  }
  //1ページ目
  &.page-first {
    position: relative;
    padding: 20vh 0 10vh;
    margin-bottom: 350px;
    height: auto;
    .input {
      display: inline-block;
      width: 80%;
      max-width: 300px;
      margin: 0 auto;
      font-size: 1rem;
      font-weight: 400;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      height: calc(1.5em + 1rem + 2px);
      padding: 0.5rem 1rem;
      line-height: 1.3;
      border-radius: 0.3rem;
      vertical-align: middle;
      &:focus {
        color: #495057;
        background-color: #fff;
        border-color: #80bdff;
        outline: 0;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
      }
    }

    .btn{
      display: inline-block;
      vertical-align: middle;
      margin-left: 5px;
    }
  }
  //2ページ目
  &.page-second {
    //中央
    .block-input-main {
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 31%;
      height: 30vh;
    }
    //周り
    .contents-input-child {
      .block-input-field {
        position: absolute;
        width: 31%;
        height: 30vh;

        &.topLeftBlock {
          top: 3vh;
          left: 2%;
        }
        &.topCenterBlock {
          top: 3vh;
          left: 0;
          right: 0;
          margin: 0 auto;
        }
        &.topRightBlock {
          top: 3vh;
          right: 2%;
        }
        &.middleLeftBlock {
          top: 0;
          bottom: 0;
          left: 2%;
          margin: auto 0;
        }
        &.middleRightBlock {
          top: 0;
          bottom: 0;
          right: 2%;
          margin: auto 0;
        }
        &.bottomLeftBlock {
          bottom: 3vh;
          left: 2%;
        }
        &.bottomCenterBlock {
          bottom: 3vh;
          left: 0;
          right: 0;
          margin: 0 auto;
        }
        &.bottomRightBlock {
          bottom: 3vh;
          right: 2%;
        }
      }
    }

    //共通9つのinput群
    .block-input-field {
      width: 100%;
      height: 30vh;
      display: flex;
      flex-wrap: wrap;

      .block-input-set {
        width: 33%;
        .textarea {
          width: 100% !important;
          height: 10vh !important;
          resize: none;
          display: block;
          width: 100%;
          height: calc(1.5em + 0.75rem + 2px);
          padding: 0.75rem 0.75rem;
          font-size: 1rem;
          font-weight: 400;
          line-height: 1.3;
          color: #495057;
          background-color: #fff;
          background-clip: padding-box;
          border: 1px solid #ced4da;
          transition: border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
          &:focus {
            color: #495057;
            background-color: #fff;
            border-color: #80bdff;
            outline: 0;
            z-index: 10;
          }
        }
      }
    }

    //set内真ん中のeditできない欄のデザイン
    .block-input-set.middleCenter {
      .textarea {
        font-weight: 900;
        background: #eee;
        color: #a5a5a5;
        text-align: center;
      }
    }
  }
}

.ttl-main{
  font-size: 14px;
  margin-bottom: 15px;
  text-align: center;
}

.txt-small{
  font-size: 10px;
  margin-top: 20px;
  text-align: center;
  color: #797979;
}

@media print{
  .page{
    ::placeholder {
      color: transparent;
    }
  }
}

</style>
